import { createSlice } from '@reduxjs/toolkit';
import { interactionInitialState } from './initialState';

export const INTERACTION_SLICE_KEY = 'mapInteraction';

const mapInteractionSlice = createSlice({
  name: INTERACTION_SLICE_KEY,
  initialState: interactionInitialState,
  reducers: {
    setSelectedMarker: (state, action) => {
      if (!action.payload) {
        state.selectedMarker = null;
        return;
      }
      // _clickId differentiates repeat taps on the same marker so store$
      // always emits a new reference without defeating reference equality on
      // the identity fields or breaking memoized selectors.
      state.selectedMarker = {
        ...action.payload,
        _clickId: Date.now()
      };
    },
    resetSelectedMarkerAndCarouselCards: (state) => {
      state.markerCards = [];
      state.sitePlanCards = [];
      state.selectedMarker = null;
    },
    setMarkerCards: (state, action) => {
      state.markerCards = action.payload;
    },
    clearMarkerCards: (state) => {
      state.markerCards = [];
    },
    setSitePlanCards: (state, action) => {
      state.sitePlanCards = action.payload;
    },
    clearSitePlanCards: (state) => {
      state.sitePlanCards = [];
    },
  },
});

export const {
  setSelectedMarker,
  resetSelectedMarkerAndCarouselCards,
  setMarkerCards,
  clearMarkerCards,
  setSitePlanCards,
  clearSitePlanCards,
} = mapInteractionSlice.actions;

export default mapInteractionSlice;
